import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/pc",
    component: () => import(/* webpackChunkName: "pc" */ "../views/Pc.vue"),
    children: [
      {
        path: "/",
        redirect: "basis"
      },
      {
        path: "basis",
        name: "Basis",
        component: () =>
          import(/* webpackChunkName: "pccontact" */ "../views/pc/Basis.vue")
      },
      {
        path: "account",
        name: "Account",
        component: () =>
          import(/* webpackChunkName: "pccontact" */ "../views/pc/Account.vue")
      },
      {
        path: "password",
        name: "Password",
        component: () =>
          import(/* webpackChunkName: "pccontact" */ "../views/pc/Password.vue")
      },
      {
        path: "meeting/:type/:status?",
        name: "Meeting",
        component: () =>
          import(/* webpackChunkName: "pcmettfile" */ "../views/pc/Meeting.vue")
      },
      {
        path: "file",
        name: "File",
        component: () =>
          import(/* webpackChunkName: "pcmettfile" */ "../views/pc/File.vue")
      }
    ]
  },
  {
    path: "/wap",
    component: () => import(/* webpackChunkName: "wap" */ "../views/Wap.vue"),
    children: [
      {
        path: "/",
        redirect: "home"
      },
      {
        path: "home",
        name: "WapHome",
        component: () =>
          import(/* webpackChunkName: "wap" */ "../views/wap/Home.vue")
      },
      {
        path: "basis",
        name: "WapBasis",
        component: () =>
          import(/* webpackChunkName: "wapcontact" */ "../views/wap/Basis.vue")
      },
      {
        path: "account",
        name: "WapAccount",
        component: () =>
          import(
            /* webpackChunkName: "wapcontact" */ "../views/wap/Account.vue"
          )
      },
      {
        path: "password",
        name: "WapPassword",
        component: () =>
          import(
            /* webpackChunkName: "wapcontact" */ "../views/wap/Password.vue"
          )
      },
      {
        path: "meeting/:type/:status?",
        name: "WapMeeting",
        component: () =>
          import(
            /* webpackChunkName: "wapmettfile" */ "../views/wap/Meeting.vue"
          )
      },
      {
        path: "file",
        name: "WapFile",
        component: () =>
          import(/* webpackChunkName: "wapmettfile" */ "../views/wap/File.vue")
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
